import { useI18next } from 'gatsby-plugin-react-i18next'

function useFormattedDate({ date, options }) {
  const { language } = useI18next()
  return new Date(date).toLocaleDateString(language, options)
}

function useFormattedDateShort(date) {
  return useFormattedDate({
    date,
    options: {
      year: 'numeric',
      month: 'long'
    }
  })
}

function useFormattedDateLong(date) {
  return useFormattedDate({
    date,
    options: {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
  })
}


export {
  useFormattedDate,
  useFormattedDateShort,
  useFormattedDateLong
}
